import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ButtonWithIcon } from '@els/els-react--button';
import { zoomSliderLevels } from '../ZoomConstants';

function ZoomSlider(props) {
  const {
    setZoomValue,
    zoomKey,
    zoomValue,
    min = zoomSliderLevels.min,
    max = zoomSliderLevels.max,
    step = zoomSliderLevels.step,
    className,
  } = props;

  const minus = () => {
    if (zoomValue === min) {
      return;
    }

    const nextValue = zoomValue - step;

    if (nextValue < min) {
      setZoomValue(zoomKey, min);
    }

    setZoomValue(zoomKey, nextValue);
  };

  const plus = () => {
    if (zoomValue === max) {
      return;
    }

    const nextValue = zoomValue + step;

    if (nextValue > max) {
      setZoomValue(zoomKey, max);
    }

    setZoomValue(zoomKey, nextValue);
  };

  return (
    <div className={classnames('zoom-slider', className)}>
      <span className="u-els-display-inline-block u-els-margin-right-1o2">Zoom structures</span>
      <ButtonWithIcon
        type="link"
        linkIconSize="xs"
        sprite="ZoomOut"
        iconOnly
        disabled={zoomValue === min}
        onClick={minus}
        className="e2e-zoom-out u-els-margin-right-1o2"
        aria-label="Zoom out"
        data-e2e="zoom-out-button">
        Zoom out
      </ButtonWithIcon>
      <ButtonWithIcon
        type="link"
        linkIconSize="xs"
        sprite="ZoomIn"
        iconOnly
        disabled={zoomValue === max}
        onClick={plus}
        className="e2e-zoom-in"
        aria-label="Zoom in"
        data-e2e="zoom-in-button">
        Zoom in
      </ButtonWithIcon>
    </div>
  );
}

ZoomSlider.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  setZoomValue: PropTypes.func,
  zoomKey: PropTypes.string,
  zoomValue: PropTypes.number,
  className: PropTypes.string,
};

export default ZoomSlider;
